;(function ($) {
    'use strict';

    /*
     * =========================================================
     * KONFIGURACE
     * =========================================================
     */
    const monthNames = [
        'Leden',
        'Únor',
        'Březen',
        'Duben',
        'Květen',
        'Červen',
        'Červenec',
        'Srpen',
        'Září',
        'Říjen',
        'Listopad',
        'Prosinec'
    ];

    const monthNamesGenitive = [
        'ledna',
        'února',
        'března',
        'dubna',
        'května',
        'června',
        'července',
        'srpna',
        'září',
        'října',
        'listopadu',
        'prosince'
    ];

    const weekdayNames = [
        'neděle',
        'pondělí',
        'úterý',
        'středa',
        'čtvrtek',
        'pátek',
        'sobota'
    ];

    const weekdayNamesTitle = [
        'Neděle',
        'Pondělí',
        'Úterý',
        'Středa',
        'Čtvrtek',
        'Pátek',
        'Sobota'
    ];

    const weekdayNamesShort = [
        'Ne',
        'Po',
        'Út',
        'St',
        'Čt',
        'Pá',
        'So'
    ];

    const bakeDayFlagClasses = {
        1: 'flag-pondeli',
        2: 'flag-utery',
        3: 'flag-streda',
        4: 'flag-ctvrtek',
        5: 'flag-patek',
        6: 'flag-sobota',
        7: 'flag-nedele'
    };

    let displayedMonth = null;
    let selectedDate = null;
    let selectedTime = null;
    let countdownInterval = null;

        /**
     * Zvýrazní den pečení podle vybraného termínu.
     *
     * Projde samostatně všechny .daysToBake:
     * - ve výpisu produktů,
     * - na detailu produktu.
     */
    function updateBakeDayFlags() {
        /*
        * Zvýraznění dne pečení se má zobrazit až
        * po POTVRZENÍ termínu vyzvednutí (tedy až
        * po volbě data i času a kliknutí na
        * "Potvrdit termín vyzvednutí"), ne hned
        * po pouhém výběru data v kalendáři.
        */
        const date = getConfirmedPickupDate();

        /*
        * Každý blok produktu zpracujeme zvlášť.
        */
        $(
            '.product .flags-default, .type-detail .p-detail .flags-default'
        ).each(function () {
            const $daysToBake = $(this);
            const $flags = $daysToBake.find('.flag');

            /*
            * Nejdříve zrušíme předchozí zvýraznění.
            */
            $flags
                .removeClass(
                    'active selected-day'
                )
                .attr(
                    'aria-current',
                    'false'
                );

            $daysToBake
                .removeAttr('data-selected-weekday')
                .removeAttr('data-selected-date');

            if (!date) {
                return;
            }

            /*
            * JavaScript:
            * 0 = neděle
            *
            * Naše mapování:
            * 1 = pondělí ... 7 = neděle
            */
            const isoWeekday = (
                date.getDay() === 0
                    ? 7
                    : date.getDay()
            );

            const selectedFlagClass =
                bakeDayFlagClasses[isoWeekday];

            if (!selectedFlagClass) {
                return;
            }

            /*
            * V rámci konkrétního produktu najdeme
            * všechny flagy daného dne.
            */
            $flags
                .filter('.' + selectedFlagClass)
                .each(function () {
                    $(this)
                        .addClass(
                            'active selected-day'
                        )
                        .attr(
                            'aria-current',
                            'true'
                        );
                });

            $daysToBake
                .attr(
                    'data-selected-weekday',
                    isoWeekday
                )
                .attr(
                    'data-selected-date',
                    formatDateForStorage(date)
                );
        });
    }

    /*
     * =========================================================
     * DATUMOVÉ FUNKCE
     * =========================================================
     */

    function createDate(year, month, day) {
        const date = new Date(year, month, day);

        date.setHours(0, 0, 0, 0);

        return date;
    }

    function getToday() {
        const today = new Date();

        today.setHours(0, 0, 0, 0);

        return today;
    }

    function cloneDate(date) {
        return new Date(date.getTime());
    }

    function addDays(date, numberOfDays) {
        const result = cloneDate(date);

        result.setDate(
            result.getDate() + numberOfDays
        );

        result.setHours(0, 0, 0, 0);

        return result;
    }

    function formatDateForStorage(date) {
        return [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, '0'),
            String(date.getDate()).padStart(2, '0')
        ].join('-');
    }

    function formatDateLong(date) {
        return (
            weekdayNamesTitle[date.getDay()]
            + ' '
            + date.getDate()
            + '.'
            + (date.getMonth() + 1)
            + '.'
            + date.getFullYear()
        );
    }

    function formatDateShort(date) {
        return (
            weekdayNames[date.getDay()]
            + ' '
            + date.getDate()
            + '.'
            + (date.getMonth() + 1)
            + '.'
        );
    }

    function formatDateResponsive(date) {
        return (
            weekdayNamesShort[date.getDay()]
            + ' '
            + date.getDate()
            + '.'
            + (date.getMonth() + 1)
            + '.'
        );
    }

    function parseStoredDate(value) {
        if (
            typeof value !== 'string'
            || !/^\d{4}-\d{2}-\d{2}$/.test(value)
        ) {
            return null;
        }

        const parts = value.split('-');

        const year = Number(parts[0]);
        const month = Number(parts[1]) - 1;
        const day = Number(parts[2]);

        const date = createDate(
            year,
            month,
            day
        );

        if (
            date.getFullYear() !== year
            || date.getMonth() !== month
            || date.getDate() !== day
        ) {
            return null;
        }

        return date;
    }

    /**
     * Vrátí datum z POTVRZENÉHO termínu vyzvednutí
     * (storagePickupKey), nebo null, pokud termín
     * ještě není potvrzený.
     *
     * Používá se všude tam, kde má dostupnost / den
     * pečení reagovat až na potvrzení termínu, ne
     * na pouhý výběr data v kalendáři.
     */
    function getConfirmedPickupDate() {
        const storedPickup = localStorage.getItem(
            calendarConfig.storagePickupKey
        );

        if (!storedPickup) {
            return null;
        }

        let pickup;

        try {
            pickup = JSON.parse(storedPickup);
        } catch (error) {
            return null;
        }

        if (!pickup || !pickup.time) return null;
        const date = parseStoredDate(pickup.date);
        return date && isDateSelectable(date) ? date : null;
    }

    function isSameDate(firstDate, secondDate) {
        return (
            firstDate.getFullYear() === secondDate.getFullYear()
            && firstDate.getMonth() === secondDate.getMonth()
            && firstDate.getDate() === secondDate.getDate()
        );
    }

    function isSameMonth(firstDate, secondDate) {
        return (
            firstDate.getFullYear() === secondDate.getFullYear()
            && firstDate.getMonth() === secondDate.getMonth()
        );
    }

    /*
     * =========================================================
     * VELIKONOCE A ČESKÉ SVÁTKY
     * =========================================================
     */

    function getEasterSunday(year) {
        const a = year % 19;
        const b = Math.floor(year / 100);
        const c = year % 100;
        const d = Math.floor(b / 4);
        const e = b % 4;
        const f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3);
        const h = (19 * a + b - d - g + 15) % 30;
        const i = Math.floor(c / 4);
        const k = c % 4;
        const l = (32 + 2 * e + 2 * i - h - k) % 7;
        const m = Math.floor(
            (a + 11 * h + 22 * l) / 451
        );

        const month = Math.floor(
            (h + l - 7 * m + 114) / 31
        );

        const day = (
            (h + l - 7 * m + 114) % 31
        ) + 1;

        return createDate(
            year,
            month - 1,
            day
        );
    }

    function getCzechHolidays(year) {
        const easterSunday = getEasterSunday(year);
        const goodFriday = addDays(easterSunday, -2);
        const easterMonday = addDays(easterSunday, 1);

        const holidays = {};

        function addHoliday(month, day, name) {
            const date = createDate(
                year,
                month - 1,
                day
            );

            holidays[
                formatDateForStorage(date)
            ] = name;
        }

        addHoliday(
            1,
            1,
            'Den obnovy samostatného českého státu'
        );

        addHoliday(
            5,
            1,
            'Svátek práce'
        );

        addHoliday(
            5,
            8,
            'Den vítězství'
        );

        addHoliday(
            7,
            5,
            'Den slovanských věrozvěstů Cyrila a Metoděje'
        );

        addHoliday(
            7,
            6,
            'Den upálení mistra Jana Husa'
        );

        addHoliday(
            9,
            28,
            'Den české státnosti'
        );

        addHoliday(
            10,
            28,
            'Den vzniku samostatného československého státu'
        );

        addHoliday(
            11,
            17,
            'Den boje za svobodu a demokracii'
        );

        addHoliday(
            12,
            24,
            'Štědrý den'
        );

        addHoliday(
            12,
            25,
            '1. svátek vánoční'
        );

        addHoliday(
            12,
            26,
            '2. svátek vánoční'
        );

        holidays[
            formatDateForStorage(goodFriday)
        ] = 'Velký pátek';

        holidays[
            formatDateForStorage(easterMonday)
        ] = 'Velikonoční pondělí';

        return holidays;
    }



    function getClosedReason(date) {
    const hours = getOpeningHoursForDate(date);

    if (hours.open) {
        return null;
    }

    return (
        hours.reason
        || 'Zavřeno'
    );
}

    function isClosedDate(date) {
        return getClosedReason(date) !== null;
    }

    /*
     * =========================================================
     * HRANIČNÍ ČAS OBJEDNÁVKY
     * =========================================================
     */

    // Jeden výpočet pro kalendář, orderBox, odpočet i potvrzení.
    function getTodayCutoffDateTime(now = new Date()) {
        return new Date(now.getFullYear(), now.getMonth(), now.getDate(),
            calendarConfig.nextDayCutoffHour, calendarConfig.nextDayCutoffMinute, 0, 0);
    }

    function isAfterTodayCutoff(now = new Date()) {
        return now.getTime() >= getTodayCutoffDateTime(now).getTime();
    }

    function getNextOpenDate(startDate, numberOfOpenDays) {
        let date = cloneDate(startDate);
        let foundOpenDays = 0;
        // Ochrana proti nekonečné smyčce při neplatné konfiguraci.
        for (let attempts = 0; foundOpenDays < numberOfOpenDays; attempts++) {
            if (attempts >= 3660) {
                throw new Error('Kalendář: v konfiguraci chybí dostupný otevřený den.');
            }
            date = addDays(date, 1);
            if (!isClosedDate(date)) foundOpenDays++;
        }
        return date;
    }

    function getMinimumSelectableDate(now = new Date()) {
        const today = createDate(now.getFullYear(), now.getMonth(), now.getDate());
        const weekday = today.getDay();
        // Čtvrtek a neděle mají pevnou hranici 12:00.
        const afterNoon = now.getHours() >= 12;
        let candidate;
        if (weekday === 4) {
            candidate = addDays(today, afterNoon ? 4 : 1);
        } else if (weekday === 5 || weekday === 6) {
            candidate = addDays(today, 8 - weekday);
        } else if (weekday === 0) {
            candidate = addDays(today, afterNoon ? 2 : 1);
        } else {
            // Pondělí až středa zachovávají původní nastavení předstihu.
            const leadDays = Number(calendarConfig.minimumLeadWorkingDays)
                + (isAfterTodayCutoff(now) ? 1 : 0);
            candidate = getNextOpenDate(today, leadDays);
        }
        // Svátky, mimořádné uzavírky a ruční otevření mají původní prioritu.
        if (isClosedDate(candidate)) candidate = getNextOpenDate(candidate, 1);
        return candidate;
    }

    function getMaximumSelectableDate() {
        return addDays(
            getToday(),
            calendarConfig.bookingHorizonDays
        );
    }

    function isDateSelectable(date) {
        const minimumDate =
            getMinimumSelectableDate();

        const maximumDate =
            getMaximumSelectableDate();

        return (
            date.getTime() >= minimumDate.getTime()
            && date.getTime() <= maximumDate.getTime()
            && !isClosedDate(date)
        );
    }

    function getOrderDeadlineForDate(pickupDate) {
        // Uzávěrka je okamžik, kdy společné pravidlo přestane termín povolovat.
        // Kontrolujeme i půlnoc (změna dne) a změny letního času přes místní Date.
        let day = addDays(pickupDate, 1);
        const noon = date => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);
        for (let i = 0; i < 3660; i++, day = addDays(day, -1)) {
            const boundaries = [addDays(day, 1), getTodayCutoffDateTime(day), noon(day), day]
                .sort((a, b) => b.getTime() - a.getTime());
            for (const boundary of boundaries) {
                const before = new Date(boundary.getTime() - 1);
                if (getMinimumSelectableDate(before).getTime() <= pickupDate.getTime()
                    && getMinimumSelectableDate(boundary).getTime() > pickupDate.getTime()) {
                    return boundary;
                }
            }
        }
        throw new Error('Kalendář: nelze určit uzávěrku termínu.');
    }

    /*
     * =========================================================
     * DOPLNĚNÍ UI
     * =========================================================
     */

    function ensureReservationUi() {
        const $reservation = $('.rezervace');

        if (
            !$reservation
                .find('.selectedDateBox')
                .length
        ) {
            $reservation
                .find('.h5')
                .after(
                    '<div class="selectedDateBox">'
                        + '<div class="selectedDateLabel">'
                            + 'Vybraný termín:'
                        + '</div>'
                        + '<div class="selectedDateRow">'
                            + '<strong class="selectedDateValue"></strong>'
                            + '<button type="button" class="changeDate">'
                                + 'Změnit datum'
                            + '</button>'
                        + '</div>'
                    + '</div>'
                );
        }

        if (
            !$reservation
                .find('.cancelSelection')
                .length
        ) {
            $reservation
                .find('> .btn-primary')
                .after(
                    '<button type="button" class="cancelSelection">'
                        + 'Zrušit výběr'
                    + '</button>'
                );
        }

        $reservation
            .find('> .btn-primary')
            .text('Potvrdit termín vyzvednutí');
    }

    /*
     * =========================================================
     * KALENDÁŘ
     * =========================================================
     */

    function initializeState() {
        const storedDate = parseStoredDate(
            localStorage.getItem(
                calendarConfig.storageDateKey
            )
        );

        if (
            storedDate
            && isDateSelectable(storedDate)
        ) {
            selectedDate = storedDate;
        } else {
            selectedDate = null;

            localStorage.removeItem(
                calendarConfig.storageDateKey
            );

            localStorage.removeItem(
                calendarConfig.storagePickupKey
            );
        }

        let storedTime = localStorage.getItem(
    calendarConfig.storageTimeKey
);

/*
 * Pokud chybí uložený čas, ale existuje
 * potvrzený termín, obnovíme čas z něj.
 */
if (!storedTime && selectedDate) {
    const storedPickup = localStorage.getItem(
        calendarConfig.storagePickupKey
    );

    if (storedPickup) {
        try {
            const pickup = JSON.parse(storedPickup);

            if (
                pickup
                && pickup.date === formatDateForStorage(selectedDate)
                && pickup.time
            ) {
                $('.rezervace .time').each(function () {
                    const slot = $.trim(
                        $(this).text()
                    );

                    if (
                        getTimeStart(slot)
                        === String(pickup.time).trim()
                    ) {
                        storedTime = slot;

                        localStorage.setItem(
                            calendarConfig.storageTimeKey,
                            slot
                        );

                        return false;
                    }
                });
            }
        } catch (error) {
            // Neplatný uložený pickup ignorujeme.
        }
    }
}

selectedTime = storedTime || null;

        const referenceDate =
            selectedDate
            || getMinimumSelectableDate();

        displayedMonth = createDate(
            referenceDate.getFullYear(),
            referenceDate.getMonth(),
            1
        );
    }

    function renderCalendar() {
        const $calendar =
            $('.rezervace .calendar');

        const $days =
            $calendar.find('.days');

        if (
            !$calendar.length
            || !$days.length
            || !displayedMonth
        ) {
            return;
        }

        const year =
            displayedMonth.getFullYear();

        const month =
            displayedMonth.getMonth();

        $calendar.attr(
            'data-month',
            year
            + '-'
            + String(month + 1).padStart(2, '0')
        );

        $calendar
            .find('.month-title')
            .text(
                monthNames[month]
                + ' '
                + year
            );

        $days
            .empty()
            .attr(
                'aria-label',
                'Kalendář '
                + monthNames[month]
                + ' '
                + year
            );

        const firstDayOfMonth = createDate(
            year,
            month,
            1
        );

        const mondayOffset = (
            firstDayOfMonth.getDay() + 6
        ) % 7;

        const gridStart = createDate(
            year,
            month,
            1 - mondayOffset
        );

        for (
            let index = 0;
            index < 42;
            index++
        ) {
            const date = addDays(
                gridStart,
                index
            );

            const dateKey =
                formatDateForStorage(date);

            const closedReason =
                getClosedReason(date);

            const selectable =
                isDateSelectable(date);

            const currentMonth =
                date.getMonth() === month;

            const weekend = (
                date.getDay() === 0
                || date.getDay() === 6
            );

            const classes = ['day'];

            const previousMonthDay = (
                date.getTime()
                < firstDayOfMonth.getTime()
            );

            if (previousMonthDay) {
                classes.push('muted');
            }

            if (weekend) {
                classes.push('weekend');
            }

            if (closedReason) {
                classes.push('holiday');
            }

            if (!selectable) {
                classes.push('disabled');
            }

            if (
                selectedDate
                && isSameDate(
                    date,
                    selectedDate
                )
            ) {
                classes.push(
                    'active',
                    'selected'
                );
            }

            let ariaLabel = (
                date.getDate()
                + '. '
                + monthNamesGenitive[
                    date.getMonth()
                ]
                + ' '
                + date.getFullYear()
            );

            if (closedReason) {
                ariaLabel +=
                    ', ' + closedReason;
            }

            const $button = $('<button>', {
                type: 'button',
                class: classes.join(' '),
                text: date.getDate(),
                role: 'gridcell',
                'data-date': dateKey,
                'aria-label': ariaLabel,
                'aria-selected': 'false'
            });

            if (closedReason) {
                $button
                    .attr(
                        'title',
                        closedReason
                    )
                    .attr(
                        'data-closed-reason',
                        closedReason
                    );
            }

            if (!selectable) {
                $button
                    .prop('disabled', true)
                    .attr(
                        'aria-disabled',
                        'true'
                    );
            }

            if (
                selectedDate
                && isSameDate(
                    date,
                    selectedDate
                )
            ) {
                $button
                    .attr(
                        'aria-selected',
                        'true'
                    )
                    .attr(
                        'aria-current',
                        'date'
                    );
            }

            $days.append($button);
        }

        updateMonthNavigation();
    }

    function updateMonthNavigation() {
        const minimumDate =
            getMinimumSelectableDate();

        const maximumDate =
            getMaximumSelectableDate();

        const minimumMonth = createDate(
            minimumDate.getFullYear(),
            minimumDate.getMonth(),
            1
        );

        const maximumMonth = createDate(
            maximumDate.getFullYear(),
            maximumDate.getMonth(),
            1
        );

        const previousDisabled = (
            displayedMonth.getTime()
            <= minimumMonth.getTime()
        );

        const nextDisabled = (
            displayedMonth.getTime()
            >= maximumMonth.getTime()
        );

        $('.rezervace .month-nav.prev')
            .prop(
                'disabled',
                previousDisabled
            )
            .toggleClass(
                'disabled',
                previousDisabled
            )
            .attr(
                'aria-disabled',
                previousDisabled
                    ? 'true'
                    : 'false'
            );

        $('.rezervace .month-nav.next')
            .prop(
                'disabled',
                nextDisabled
            )
            .toggleClass(
                'disabled',
                nextDisabled
            )
            .attr(
                'aria-disabled',
                nextDisabled
                    ? 'true'
                    : 'false'
            );
    }

    function showPreviousMonth() {
        const previousMonth = createDate(
            displayedMonth.getFullYear(),
            displayedMonth.getMonth() - 1,
            1
        );

        const minimumDate =
            getMinimumSelectableDate();

        const minimumMonth = createDate(
            minimumDate.getFullYear(),
            minimumDate.getMonth(),
            1
        );

        if (
            previousMonth.getTime()
            < minimumMonth.getTime()
        ) {
            return;
        }

        displayedMonth = previousMonth;

        renderCalendar();
    }

    function showNextMonth() {
        const nextMonth = createDate(
            displayedMonth.getFullYear(),
            displayedMonth.getMonth() + 1,
            1
        );

        const maximumDate =
            getMaximumSelectableDate();

        const maximumMonth = createDate(
            maximumDate.getFullYear(),
            maximumDate.getMonth(),
            1
        );

        if (
            nextMonth.getTime()
            > maximumMonth.getTime()
        ) {
            return;
        }

        displayedMonth = nextMonth;

        renderCalendar();
    }

    /*
     * =========================================================
     * STAVY PANELU
     * =========================================================
     */

    function showDateSelectionStep() {
        const $reservation = $('.rezervace');

        $reservation
            .removeClass('has-selected-date')
            .addClass('selecting-date');

        /*
        * Úvodní text.
        */
       

        /*
        * Nadpis Vyberte den je při výběru data vidět.
        * Jde o .h6, která je přímo před .calendar.
        */
        $reservation
            .find('.calendar')
            .prev('.h6')
            .show();

        $reservation
            .find('.selectedDateBox')
            .hide();

        $reservation
            .find('.calendar')
            .show();

        /*
        * Výběr času je vždy vidět.
        */
        $reservation
            .find('.time-select')
            .show();

        $reservation
            .find('.time-select .h6')
            .text('Vyberte čas');

        $reservation
            .find('> .btn-primary')
            .addClass('notApplied')
            .prop('disabled', true)
            .attr('aria-disabled', 'true');

        $reservation
            .find('.cancelSelection')
            .toggle(
                Boolean(
                    selectedDate || selectedTime
                )
            );
    }

    function showTimeSelectionStep() {
        if (!selectedDate) {
            showDateSelectionStep();
            return;
        }

        const $reservation = $('.rezervace');

        $reservation
            .removeClass('selecting-date')
            .addClass('has-selected-date');

        /*
        * Hlavní úvod už po výběru data nepotřebujeme.
        */
        
        /*
        * Schová nadpis Vyberte den.
        */
        $reservation
            .find('.calendar')
            .prev('.h6')
            .hide();

        $reservation
            .find('.selectedDateBox')
            .show();

        updateSelectedDateText();

        /*
        * Po výběru data kalendář schováme.
        */
        $reservation
            .find('.calendar')
            .hide();

        /*
        * Časy zůstávají vždy viditelné.
        */
        $reservation
            .find('.time-select')
            .show();

        $reservation
            .find('.time-select .h6')
            .text('Vyberte čas');

        $reservation
            .find('.cancelSelection')
            .show();

       updateTimeSlots();
renderSelectedTime();
updateConfirmationButton();
    }

    function updateSelectedDateText() {
        const $value = $('.rezervace .selectedDateValue');

        if (!selectedDate) {
            $value.text('');
            return;
        }

        let text = formatDateLong(selectedDate);

        if (selectedTime) {
            text += ', ' + selectedTime;
        } else {
            text += ', vyberte čas';
        }

        $value.text(text);
    }
    /*
     * =========================================================
     * VÝBĚR DATA A ČASU
     * =========================================================
     */

  function selectDate(date) {
    if (!isDateSelectable(date)) {
        return;
    }

    selectedDate = date;
    selectedTime = null;

    localStorage.setItem(
        calendarConfig.storageDateKey,
        formatDateForStorage(date)
    );

    localStorage.removeItem(
        calendarConfig.storageTimeKey
    );

    localStorage.removeItem(
        calendarConfig.storagePickupKey
    );

    $('.rezervace')
        .removeAttr('data-selected-time')
        .removeAttr('data-confirmed')
        .attr(
            'data-selected-date',
            formatDateForStorage(date)
        );

renderCalendar();
updateTimeSlots();
renderSelectedTime();
updateSelectedDateText();
    updateOrderBox();
    updateBakeDayFlags();
    loadDetailProductAvailability();
    updateHeaderCartAccess();
    updateCartPickupNotice();
    renderPickupInCart();
    showTimeSelectionStep();
    updateResponsiveReservationButton();

    /*
     * Aktualizace infoBoxu bez refreshování stránky.
     * Protože termín zatím není potvrzený,
     * původní infoBox se odstraní.
     */
    renderCategoryInfoBox();

    $(document).trigger(
        'klasekDateSelected',
        [{
            date: formatDateForStorage(date),

            isoWeekday:
                date.getDay() === 0
                    ? 7
                    : date.getDay(),

            weekday:
                weekdayNames[
                    date.getDay()
                ]
        }]
    );
}

function updateTimeSlots() {
    const $reservation = $('.rezervace');
    const $times = $reservation.find('.times');
    const $buttons = $times.find('.time');

    let $closedMessage =
        $times.find('.closed-day-message');

    if (!$closedMessage.length) {
        $closedMessage = $('<div>', {
            class: 'closed-day-message'
        }).hide();

        $times.append($closedMessage);
    }

    if (!selectedDate) {
        $buttons
            .show()
            .prop('disabled', false)
            .attr('aria-disabled', 'false');

        $closedMessage.hide();

        return;
    }

    const hours =
        getOpeningHoursForDate(selectedDate);

    /*
     * Vybraný den je zavřený.
     */
    if (!hours.open) {
        $buttons
            .hide()
            .removeClass('active selected')
            .prop('disabled', true)
            .attr('aria-selected', 'false')
            .attr('aria-disabled', 'true');

        selectedTime = null;

        localStorage.removeItem(
            calendarConfig.storageTimeKey
        );

        $reservation
            .removeAttr('data-selected-time');

        $closedMessage
            .text(
                calendarConfig.closedDayMessage
                || 'V tento den máme zavřeno. Vyberte prosím jiný termín vyzvednutí.'
            )
            .show();

        updateSelectedDateText();
        updateConfirmationButton();

        return;
    }

    $closedMessage.hide();

    const openFrom =
        timeToMinutes(hours.from);

    const openTo =
        timeToMinutes(hours.to);

    let selectedTimeStillAvailable = false;

    $buttons.each(function () {
        const $button = $(this);

        const text =
            $.trim($button.text());

        const parts =
            text.split('-');

        if (parts.length !== 2) {
            $button.hide();

            return;
        }

        const slotFrom =
            timeToMinutes(
                parts[0].trim()
            );

        const slotTo =
            timeToMinutes(
                parts[1].trim()
            );

        /*
         * Celý časový slot musí být uvnitř
         * otevírací doby.
         *
         * Pátek:
         *
         * openTo = 16:00
         *
         * 15:00 - 15:59 => ANO
         * 16:00 - 16:59 => NE
         */
        const available = (
            slotFrom !== null
            && slotTo !== null
            && openFrom !== null
            && openTo !== null
            && slotFrom <= slotTo
            && slotFrom >= openFrom
            && slotTo < openTo
        );

        $button
            .toggle(available)
            .prop('disabled', !available)
            .attr(
                'aria-disabled',
                available
                    ? 'false'
                    : 'true'
            );

        if (
            available
            && selectedTime
            && text === selectedTime
        ) {
            selectedTimeStillAvailable = true;
        }
    });

    /*
     * Pokud je uložený čas z předchozího dne
     * a nový den ho nepovoluje, smažeme ho.
     */
    if (
        selectedTime
        && !selectedTimeStillAvailable
    ) {
        selectedTime = null;

        localStorage.removeItem(
            calendarConfig.storageTimeKey
        );

        $reservation
            .removeAttr('data-selected-time');

        $buttons
            .removeClass('active selected')
            .attr(
                'aria-selected',
                'false'
            );
    }

    updateSelectedDateText();
    updateConfirmationButton();
}

    function renderSelectedTime() {
        $('.rezervace .time')
            .removeClass('active selected')
            .attr('aria-selected', 'false');

        if (selectedTime) {
            $('.rezervace .time').each(function () {
                const $button = $(this);

                if (
                    $.trim($button.text()) === selectedTime
                ) {
                    $button
                        .addClass('active selected')
                        .attr('aria-selected', 'true');
                }
            });
        }

        updateSelectedDateText();
        updateConfirmationButton();
    }

   function selectTime($button) {
    if (
        !selectedDate
        || $button.prop('disabled')
        || !$button.is(':visible')
    ) {
        return;
    }

    $('.rezervace .time')
        .removeClass('active selected')
        .attr('aria-selected', 'false');

    $button
        .addClass('active selected')
        .attr('aria-selected', 'true');

    selectedTime = $.trim(
        $button.text()
    );

    localStorage.setItem(
        calendarConfig.storageTimeKey,
        selectedTime
    );

    localStorage.removeItem(
        calendarConfig.storagePickupKey
    );

    $('.rezervace')
        .removeAttr('data-confirmed')
        .attr(
            'data-selected-time',
            selectedTime
        );

    updateSelectedDateText();
    updateConfirmationButton();
    updateResponsiveReservationButton();

    /*
     * Aktualizace infoBoxu bez refreshování.
     */
    renderCategoryInfoBox();

    $(document).trigger(
        'klasekTimeSelected',
        [{
            time: selectedTime
        }]
    );
}


    function updateConfirmationButton() {
        const canConfirm = Boolean(
            selectedDate
            && isDateSelectable(selectedDate)
            && selectedTime
        );

        $('.rezervace > .btn-primary')
            .toggleClass(
                'notApplied',
                !canConfirm
            )
            .prop(
                'disabled',
                !canConfirm
            )
            .attr(
                'aria-disabled',
                canConfirm
                    ? 'false'
                    : 'true'
            );
    }

    /*
     * =========================================================
     * ORDER BOX A ODPOČET
     * =========================================================
     */

    function formatRemainingTime(
        milliseconds
    ) {
        if (milliseconds <= 0) {
            return 'objednávky uzavřeny';
        }

        const totalMinutes = Math.floor(
            milliseconds / 60000
        );

        const days = Math.floor(
            totalMinutes / 1440
        );

        const hours = Math.floor(
            (totalMinutes % 1440) / 60
        );

        const minutes =
            totalMinutes % 60;

        const parts = [];

        if (days > 0) {
            parts.push(
                days + ' d'
            );
        }

        parts.push(
            String(hours)
                .padStart(2, '0')
            + ' hod'
        );

        parts.push(
            String(minutes)
                .padStart(2, '0')
            + ' min'
        );

        return parts.join(' ');
    }

    function updateOrderBox() {
    const $orderBox =
        $('.orderBox');

    if (!$orderBox.length) {
        return;
    }

    /*
     * ORDER BOX JE NEZÁVISLÝ NA selectedDate.
     *
     * Zobrazuje vždy nejbližší termín, na který je právě možné
     * objednávat podle:
     * - minimumLeadWorkingDays,
     * - zavřených dnů,
     * - nextDayCutoffHour,
     * - nextDayCutoffMinute.
     *
     * Vybrané datum v kalendáři tedy obsah boxu nijak nemění.
     */
    const orderDate =
        getMinimumSelectableDate();

    const deadline =
        getOrderDeadlineForDate(
            orderDate
        );

    const remainingMilliseconds = (
        deadline.getTime()
        - new Date().getTime()
    );

    $orderBox
        .removeClass('empty')
        .toggleClass(
            'closed',
            remainingMilliseconds <= 0
        )
        .toggleClass(
            'active',
            remainingMilliseconds > 0
        );

    $orderBox
        .find('.date')
        .text(
            formatDateShort(
                orderDate
            )
        );

    $orderBox
        .find('.left')
        .show();

    $orderBox
        .find('.leftValue')
        .text(
            formatRemainingTime(
                remainingMilliseconds
            )
        );

    $orderBox.attr(
        'data-order-deadline',
        deadline.toISOString()
    );
}

    let lastCalendarClockKey = null;
    function refreshCalendarClock() {
        const now = new Date();
        const key = formatDateForStorage(now) + ':'
            + formatDateForStorage(getMinimumSelectableDate(now));
        if (key !== lastCalendarClockKey) {
            lastCalendarClockKey = key;
            if (selectedDate && !isDateSelectable(selectedDate)) {
                clearSelection();
            } else {
                renderCalendar();
                updateTimeSlots();
                updateConfirmationButton();
            }
        }
        updateOrderBox();
    }

    function startOrderCountdown() {
        if (countdownInterval) {
            clearInterval(
                countdownInterval
            );
        }

        refreshCalendarClock();

        countdownInterval =
            window.setInterval(
                refreshCalendarClock,
                1000
            );
    }

    /*
     * =========================================================
     * RESPONSIVE TLAČÍTKO
     * =========================================================
     */

    function updateResponsiveReservationButton() {
        const $button = $(
            '.responsive-tools .btn.btn-third, .mobileReservationDate .btn.btn-third'
        );

        if (!$button.length) {
            return;
        }

        const storedPickup =
            localStorage.getItem(
                calendarConfig.storagePickupKey
            );

        if (!storedPickup) {
            $button
                .text('Vybrat termín')
                .removeClass(
                    'has-reservation'
                );

            return;
        }

        try {
            const pickup =
                JSON.parse(storedPickup);

            const date =
                parseStoredDate(
                    pickup.date
                );

            if (
                !date
                || !pickup.time
            ) {
                throw new Error(
                    'Neplatný termín.'
                );
            }

            $button
                .text(
                    formatDateResponsive(date)
                    + ' '
                    + pickup.time
                )
                .addClass(
                    'has-reservation'
                );
        } catch (error) {
            localStorage.removeItem(
                calendarConfig.storagePickupKey
            );

            $button
                .text('Vybrat termín')
                .removeClass(
                    'has-reservation'
                );
        }
    }

    function getTimeStart(timeRange) {
        if (!timeRange) {
            return '';
        }

        return String(timeRange)
            .split('-')[0]
            .trim();
    }

    /*
     * =========================================================
     * POTVRZENÍ A ZRUŠENÍ
     * =========================================================
     */

 function confirmPickup() {
    if (
        !selectedDate
        || !selectedTime
    ) {
        return;
    }

    updateTimeSlots();
    if (!selectedTime) return;

    const deadline =
        getOrderDeadlineForDate(
            selectedDate
        );

    if (
        !isDateSelectable(selectedDate)
        || new Date().getTime() >= deadline.getTime()
    ) {
        alert(
            'Objednávky na tento termín jsou již uzavřené.'
        );

        selectedDate = null;
        selectedTime = null;

        localStorage.removeItem(
            calendarConfig.storageDateKey
        );

        localStorage.removeItem(
            calendarConfig.storageTimeKey
        );

        localStorage.removeItem(
            calendarConfig.storagePickupKey
        );

        renderCalendar();
        renderSelectedTime();
        updateOrderBox();
        renderCategoryInfoBox();
        showDateSelectionStep();
        updateResponsiveReservationButton();

        updateBakeDayFlags();
        loadDetailProductAvailability();
        updateHeaderCartAccess();
        updateCartPickupNotice();
        renderPickupInCart();

        return;
    }

    const pickup = {
        date: formatDateForStorage(selectedDate),

        time: getTimeStart(selectedTime),

        weekday:
            weekdayNames[
                selectedDate.getDay()
            ],

        isoWeekday:
            selectedDate.getDay() === 0
                ? 7
                : selectedDate.getDay(),

        orderDeadline: deadline.toISOString(),
        confirmedAt: new Date().toISOString()
    };

    localStorage.setItem(
    calendarConfig.storageTimeKey,
    selectedTime
);

localStorage.setItem(
    calendarConfig.storagePickupKey,
    JSON.stringify(pickup)
);

    $('.rezervace')
        .attr(
            'data-selected-date',
            pickup.date
        )
        .attr(
            'data-selected-time',
            pickup.time
        )
        .attr(
            'data-confirmed',
            '1'
        )
        .addClass(
            'is-confirmed'
        )
        .removeClass(
            'visible'
        );
    $('.custom-variant-wrap > .calendar-message').remove();
    updateResponsiveReservationButton();
    updateOrderBox();

    /*
     * Tady se infoBox ihned přepíše
     * podle právě potvrzeného termínu.
     */
    renderCategoryInfoBox();

    /*
     * Až teď, po potvrzení termínu, se má
     * zvýraznit den pečení a načíst dostupnost
     * produktů/variant pro zvolený termín.
     */
    updateBakeDayFlags();
    loadDetailProductAvailability();
    updateHeaderCartAccess();
    updateCartPickupNotice();
    renderPickupInCart();

    $(document).trigger(
        'klasekPickupConfirmed',
        [pickup]
    );
}

   function clearSelection() {
        selectedDate = null;
        selectedTime = null;

        localStorage.removeItem(
            calendarConfig.storageDateKey
        );

        localStorage.removeItem(
            calendarConfig.storageTimeKey
        );

        localStorage.removeItem(
            calendarConfig.storagePickupKey
        );

        $('.rezervace')
            .removeAttr('data-selected-date')
            .removeAttr('data-selected-time')
            .removeAttr('data-confirmed')
            .removeClass(
                'has-selected-date is-confirmed'
            );

        displayedMonth = createDate(
            getMinimumSelectableDate()
                .getFullYear(),

            getMinimumSelectableDate()
                .getMonth(),

            1
        );

        renderCalendar();
        renderSelectedTime();
        updateOrderBox();
        showDateSelectionStep();
        updateResponsiveReservationButton();

        detailAvailabilityData = null;

        updateBakeDayFlags();
        loadDetailProductAvailability();
        updateHeaderCartAccess();
        updateCartPickupNotice();
        renderPickupInCart();

        /*
        * Odstraní infoBox, protože už není
        * uložený potvrzený termín.
        */
        renderCategoryInfoBox();
    }

    /*
     * =========================================================
     * UDÁLOSTI
     * =========================================================
     */

    $(document).on(
        'click',
        '.rezervace .month-nav.prev:not(:disabled)',
        function (event) {
            event.preventDefault();
            event.stopPropagation();

            showPreviousMonth();
        }
    );

    $(document).on(
        'click',
        '.rezervace .month-nav.next:not(:disabled)',
        function (event) {
            event.preventDefault();
            event.stopPropagation();

            showNextMonth();
        }
    );

    $(document).on(
        'click',
        '.rezervace .calendar .day:not(:disabled)',
        function (event) {
            event.preventDefault();

            const date = parseStoredDate(
                $(this).attr(
                    'data-date'
                )
            );

            if (!date) {
                return;
            }

            if (
                !isSameMonth(
                    date,
                    displayedMonth
                )
            ) {
                displayedMonth = createDate(
                    date.getFullYear(),
                    date.getMonth(),
                    1
                );
            }

            selectDate(date);
        }
    );

    $(document).on(
        'click',
        '.rezervace .changeDate',
        function (event) {
            event.preventDefault();

            showDateSelectionStep();
        }
    );

    $(document).on(
        'click',
        '.rezervace .time',
        function (event) {
            event.preventDefault();

            selectTime(
                $(this)
            );
        }
    );

    $(document).on(
        'click',
        '.rezervace > .btn-primary',
        function (event) {
            event.preventDefault();

            if (
                $(this).hasClass(
                    'notApplied'
                )
                || $(this).prop(
                    'disabled'
                )
                || !selectedDate
                || !selectedTime
            ) {
                return;
            }

            confirmPickup();
        }
    );

    $(document).on(
        'click',
        '.rezervace .cancelSelection',
        function (event) {
            event.preventDefault();

            clearSelection();
        }
    );

    $(document).on(
        'click',
        '.responsive-tools .btn.btn-third, .mobileReservationDate .btn.btn-third',
        function (event) {
            event.preventDefault();

            $('.rezervace')
                .addClass('visible');

            if (selectedDate) {
                showTimeSelectionStep();
            } else {
                showDateSelectionStep();
            }
        }
    );

    $(document).on(
        'click',
        '.rezervace .close',
        function (event) {
            event.preventDefault();

            $('.rezervace')
                .removeClass(
                    'active is-open visible'
                );
        }
    );


    function formatDateDetailShort(date) {
        return (
            weekdayNamesShort[date.getDay()]
            + ' '
            + date.getDate()
            + '.'
            + (date.getMonth() + 1)
            + '.'
            + date.getFullYear()
        );
    }

/*
 * Data načtená z endpointu pro detail produktu.
 */
let detailAvailabilityData = null;

let detailAvailabilityRequest = null;
let detailAvailabilityRequestId = 0;

const availabilityEndpointUrl =
    'https://php.shopcode.cz/api/klasek/api-availability.php';


/**
 * Vrátí produktové kódy jednotlivých variant.
 *
 * Kódy bere z:
 *
 * data-product-code="30002"
 *
 * například:
 *
 * <div
 *     class="variant haveVariant defaultVariant"
 *     data-product-code="30002"
 * >
 */
function getDetailProductCodes() {
    const codes = [];

    $(
        '.custom-variant-wrap '
        + '.variant[data-product-code]'
    ).each(function () {
        const code = String(
            $(this).attr('data-product-code')
            || ''
        ).trim();

        if (code !== '') {
            codes.push(code);
        }
    });

    /*
     * Pokud jsou kódy přímo u variant,
     * použijeme je.
     */
    if (codes.length) {
        return Array.from(
            new Set(codes)
        );
    }

    /*
     * Záložní řešení pro produkt,
     * který nemá vlastní varianty.
     */
    try {
        if (
            typeof window.getShoptetDataLayer
            !== 'function'
        ) {
            return [];
        }

        const productData =
            window.getShoptetDataLayer(
                'product'
            );

        if (!productData) {
            return [];
        }

        let rawCodes = [];

        if (Array.isArray(productData.codes)) {
            rawCodes = productData.codes;
        } else if (productData.codes) {
            rawCodes = [
                productData.codes
            ];
        } else if (productData.code) {
            rawCodes = [
                productData.code
            ];
        }

        const fallbackCodes = [];

        rawCodes.forEach(function (item) {
            if (
                typeof item === 'string'
                || typeof item === 'number'
            ) {
                const code = String(
                    item
                ).trim();

                if (code !== '') {
                    fallbackCodes.push(code);
                }

                return;
            }

            if (
                item
                && typeof item === 'object'
            ) {
                const possibleCode =
                    item.code
                    || item.productCode
                    || item.value
                    || item.sku
                    || '';

                const code = String(
                    possibleCode
                ).trim();

                if (code !== '') {
                    fallbackCodes.push(code);
                }
            }
        });

        return Array.from(
            new Set(fallbackCodes)
        );
    } catch (error) {
        console.error(
            'Nepodařilo se získat kód produktu.',
            error
        );

        return [];
    }
}


/**
 * Vrátí produkty z endpointu jako mapu:
 *
 * {
 *     "30002": {...},
 *     "30001": {...}
 * }
 */
function getDetailAvailabilityProductsByCode() {
    const productsByCode = {};

    if (
        !detailAvailabilityData
        || !Array.isArray(
            detailAvailabilityData.products
        )
    ) {
        return productsByCode;
    }

    detailAvailabilityData.products.forEach(
        function (product) {
            if (!product) {
                return;
            }

            const code = String(
                product.code || ''
            ).trim();

            if (code !== '') {
                productsByCode[code] =
                    product;
            }
        }
    );

    return productsByCode;
}


/**
 * Z textu varianty odstraní předchozí
 * text dostupnosti.
 *
 * Například:
 *
 * Varianta: 500 g - Momentálně nedostupné
 *
 * převede na:
 *
 * Varianta: 500 g
 */
function getOriginalVariantLabel($label) {
    if (!$label.length) {
        return '';
    }

    let originalLabel = $label.attr(
        'data-original-label'
    );

    if (originalLabel) {
        return originalLabel;
    }

    originalLabel = $.trim(
        $label.text()
    );

   /* originalLabel = originalLabel.replace(
        /\s*-\s*(?:Momentálně nedostupné|Nedostupné|Dostupné(?:\s+\d+\s*ks)?|Ověřujeme dostupnost)$/i,
        ''
    );*/

    $label.attr(
        'data-original-label',
        originalLabel
    );

    return originalLabel;
}


/**
 * Nastaví variantu do stavu načítání.
 */
function setDetailVariantLoading(
    $variant,
    $label,
    $amount,
    $button,
    originalLabel
) {
    $variant
        .removeClass(
            'is-available is-unavailable'
        )
        .addClass('is-loading')
        .attr(
            'aria-busy',
            'true'
        )
        .removeAttr(
            'data-limit-quantity'
        )
        .removeAttr(
            'data-reserved-quantity'
        )
        .removeAttr(
            'data-available-quantity'
        );

    if ($label.length) {
        $label.text(
            originalLabel
            + ' - Ověřujeme dostupnost'
        );
    }

    if ($amount.length) {
        $amount.prop(
            'disabled',
            true
        );
    }

    if ($button.length) {
        $button
            .prop(
                'disabled',
                true
            )
            .attr(
                'aria-disabled',
                'true'
            )
            .addClass('disabled');

        const $buttonText =
            $button.find('span').first();

        if ($buttonText.length) {
            $buttonText.text(
                'Ověřujeme'
            );
        } else {
            $button.text(
                'Ověřujeme'
            );
        }
    }
}


/**
 * Nastaví variantu jako dostupnou.
 */
function setDetailVariantAvailable(
    $variant,
    $label,
    $amount,
    $button,
    originalLabel,
    limitQuantity,
    reservedQuantity,
    availableQuantity
) {
    $variant
        .removeClass(
            'is-loading is-unavailable'
        )
        .addClass('is-available')
        .attr(
            'aria-busy',
            'false'
        )
        .attr(
            'aria-disabled',
            'false'
        )
        .attr(
            'data-limit-quantity',
            limitQuantity
        )
        .attr(
            'data-reserved-quantity',
            reservedQuantity
        )
        .attr(
            'data-available-quantity',
            availableQuantity
        );

    if ($label.length) {
        $label.text(
            originalLabel
           /* + ' - Dostupné '
            + availableQuantity
            + ' ks'*/
        );
    }


    if ($amount.length) {
        let currentAmount = Number(
            $amount.val()
        ) || 1;

        currentAmount = Math.max(
            1,
            Math.min(
                currentAmount,
                availableQuantity
            )
        );

        $amount
            .prop(
                'disabled',
                false
            )
            .attr(
                'min',
                1
            )
            .attr(
                'max',
                availableQuantity
            )
            /*
             * Autoritativní zdroj limitu pro veškerou
             * naši validaci (tlačítko +, ruční zadání,
             * reserveVariant v _1-variants.js). Na rozdíl
             * od "max" ho nepřepisuje nic jiného, takže
             * i kdyby něco venku změnilo "max", skutečná
             * rezervace zůstane správně omezená.
             */
            .attr(
                'data-effective-max-quantity',
                availableQuantity
            )
            .val(
                currentAmount
            );
    }

    /*
     * Aktualizace tooltipu tlačítka plus.
     *
     * data-original-title používá Bootstrap
     * tooltip na Shoptetu.
     */
    const $increaseTooltip = $variant
        .find('.increase-tooltip')
        .first();

    if ($increaseTooltip.length) {
        const maximumMessage =
            hlaskamnozstvi
            + availableQuantity
            + ' ks.'
            + hlaskazamnozstvim;

        $increaseTooltip
            .attr(
                'data-original-title',
                maximumMessage
            )
            .attr(
                'title',
                maximumMessage
            );

        /*
         * Pokud už byl Bootstrap tooltip vytvořen,
         * aktualizujeme i jeho uložený titul.
         */
        $increaseTooltip.data(
            'original-title',
            maximumMessage
        );
    }

    /*
     * Pro jistotu aktualizujeme také aria-label
     * tlačítka pro zvýšení množství.
     */
    $variant
        .find('.quantity .increase')
        .first()
        .attr(
            'aria-label',
            'Zvýšit množství o 1, maximálně '
            + availableQuantity
            + ' ks'
        );

    if ($button.length) {
        $button
            .prop(
                'disabled',
                false
            )
            .attr(
                'aria-disabled',
                'false'
            )
            .removeClass('disabled');

        const $buttonText =
            $button.find('span').first();

        if ($buttonText.length) {
            $buttonText.text(
                'Rezervovat'
            );
        } else {
            $button.text(
                'Rezervovat'
            );
        }
    }
}

/*
 * Tyto dva handlery se registrují JEDNOU při načtení
 * skriptu (ne uvnitř setDetailVariantAvailable - tam byly
 * omylem vnořené kvůli chybějící uzavírací závorce a při
 * každém přepočtu dostupnosti se znovu a znovu duplikovaly).
 */
$(document).off(
    'input.detailVariantAmount change.detailVariantAmount blur.detailVariantAmount',
    '.custom-variant-wrap .customCart input.amount'
).on(
    'input.detailVariantAmount change.detailVariantAmount blur.detailVariantAmount',
    '.custom-variant-wrap .customCart input.amount',
    function () {
        normalizeDetailAmount($(this));
    }
);

$(document).off(
    'click.detailVariantIncrease',
    '.custom-variant-wrap .quantity .increase'
).on(
    'click.detailVariantIncrease',
    '.custom-variant-wrap .quantity .increase',
    function (event) {
        const $variant = $(this)
            .closest('.variant');

        const $amount = $variant
            .find('.customCart input.amount')
            .first();

        if (!$amount.length) {
            return;
        }

        /*
         * Autoritativní limit (data-effective-max-quantity),
         * ne holý "max" atribut - ten může být přepsaný
         * jiným skriptem.
         */
        const effectiveMaxRaw =
            $amount.attr('data-effective-max-quantity');

        const maximum =
            effectiveMaxRaw !== undefined
                ? (Number(effectiveMaxRaw) || 0)
                : (Number($amount.attr('max')) || 1);

        const current =
            Number($amount.val()) || 1;

        if (current >= maximum) {
            event.preventDefault();
            event.stopImmediatePropagation();

            $amount.val(maximum);

            return false;
        }

        /*
         * Defenzivně srovnáme "max" zpět podle
         * autoritativní hodnoty, kdyby se mezitím
         * rozjely.
         */
        if (effectiveMaxRaw !== undefined) {
            $amount.attr('max', maximum);
        }
    }
);


/**
 * Nastaví variantu jako nedostupnou.
 */
function setDetailVariantUnavailable(
    $variant,
    $label,
    $amount,
    $button,
    originalLabel,
    limitQuantity,
    reservedQuantity,
    availableQuantity
) {
    $variant
        .removeClass(
            'is-loading is-available'
        )
        .addClass('is-unavailable')
        .attr(
            'aria-busy',
            'false'
        )
        .attr(
            'aria-disabled',
            'true'
        )
        .attr(
            'data-limit-quantity',
            limitQuantity
        )
        .attr(
            'data-reserved-quantity',
            reservedQuantity
        )
        .attr(
            'data-available-quantity',
            availableQuantity
        );

    if ($label.length) {
        $label.text(
            originalLabel
           // + ' - Momentálně nedostupné'
        );
    }

    if ($amount.length) {
        $amount
            .prop(
                'disabled',
                true
            )
            .attr(
                'max',
                0
            )
            .attr(
                'data-effective-max-quantity',
                0
            )
            .val(
                1
            );
    }

    if ($button.length) {
        $button
            .prop(
                'disabled',
                true
            )
            .attr(
                'aria-disabled',
                'true'
            )
            .addClass('disabled');

        const $buttonText =
            $button.find('span').first();

        if ($buttonText.length) {
            $buttonText.text(
                'Nedostupné'
            );
        } else {
            $button.text(
                'Nedostupné'
            );
        }
    }
}


function isDetailProductBakeDay(date) {
    if (!date) {
        return false;
    }

    const isoWeekday =
        date.getDay() === 0
            ? 7
            : date.getDay();

    const selectedFlagClass =
        bakeDayFlagClasses[isoWeekday];

    if (!selectedFlagClass) {
        return false;
    }

    const $flagsWrapper = $(
        '.type-detail .p-detail .flags-default'
    ).first();

    if (!$flagsWrapper.length) {
        return false;
    }

    return (
        $flagsWrapper
            .find('.flag.' + selectedFlagClass)
            .length > 0
    );
}

/**
 * Jednorázově zachytí skladový (native) max varianty,
 * dřív než updateDetailVariantAvailability tato data
 * přepíše hodnotami z API (denní pekařský limit).
 *
 * Zdroj skladové hodnoty:
 * 1. max na input.amount, který nastavil _1-variants.js
 *    podle necessaryVariantData.maximumAmount (skutečný
 *    sklad/limit ze Shoptetu).
 * 2. Záložně data-available-quantity, které bylo
 *    vyrenderované rovnou v HTML při načtení stránky.
 *
 * Uloží se do vlastního atributu data-native-max-quantity,
 * který updateDetailVariantAvailability už nikdy nemaže,
 * takže skladový limit zůstává zachovaný napříč opakovanými
 * přepočty dostupnosti (např. po změně termínu vyzvednutí).
 */
function captureNativeVariantMax($variant, $amount) {
    if (
        $variant.attr('data-native-max-quantity')
            !== undefined
    ) {
        return;
    }

    const fromAmount = Number(
        $amount.attr('max')
    );

    const fromVariant = Number(
        $variant.attr('data-available-quantity')
    );

    const nativeMax =
        Number.isFinite(fromAmount) && fromAmount > 0
            ? fromAmount
            : (
                Number.isFinite(fromVariant)
                && fromVariant >= 0
                    ? fromVariant
                    : Infinity
            );

    $variant.attr(
        'data-native-max-quantity',
        nativeMax
    );
}

/**
 * Propíše dostupnost z endpointu
 * ke každé variantě zvlášť.
 */
function updateDetailVariantAvailability() {
    const productsByCode =
        getDetailAvailabilityProductsByCode();

    $(
        '.custom-variant-wrap '
        + '.variant[data-product-code]'
    ).each(function () {
        const $variant = $(this);

        const code = String(
            $variant.attr(
                'data-product-code'
            ) || ''
        ).trim();

        const $label = $variant
            .find('.text .label')
            .first();

        /*
         * Pozn.: v této šabloně není input.amount
         * ani tlačítko obalené ve <form class="pr-action">,
         * hledáme proto rovnou uvnitř .customCart.
         */
        const $amount = $variant
            .find('.customCart input.amount')
            .first();

        const $button = $variant
            .find(
                '.customCart .add-to-cart-button'
            )
            .first();

        // Musí proběhnout dřív, než níže dojde k mazání
        // data-available-quantity a přepsání hodnotou z API.
        captureNativeVariantMax($variant, $amount);

        const originalLabel =
            getOriginalVariantLabel(
                $label
            );

            if (selectedDate && !isDetailProductBakeDay(selectedDate)) {
    setDetailVariantUnavailable(
        $variant,
        $label,
        $amount,
        $button,
        originalLabel,
        0,
        0,
        0
    );

    return;
}
        /*
         * Předchozí stav varianty.
         */
        $variant
            .removeClass(
                'is-loading '
                + 'is-available '
                + 'is-unavailable'
            )
            .removeAttr(
                'aria-busy'
            )
            .removeAttr(
                'aria-disabled'
            )
            .removeAttr(
                'data-limit-quantity'
            )
            .removeAttr(
                'data-reserved-quantity'
            )
            .removeAttr(
                'data-available-quantity'
            );

        /*
         * Bez vybraného data neprovádíme
         * kontrolu dostupnosti.
         */
      const $variantWrap = $variant
    .closest('.custom-variant-wrap');

/*
 * Dokud není vybrané datum I čas,
 * zobrazujeme hlášku "Vyberte termín".
 */
if (!selectedDate || !selectedTime) {
    $variant
        .removeClass(
            'is-loading is-available'
        )
        .addClass(
            'is-unavailable'
        )
        .attr(
            'aria-busy',
            'false'
        )
        .attr(
            'aria-disabled',
            'true'
        )
        .removeAttr(
            'data-limit-quantity'
        )
        .removeAttr(
            'data-reserved-quantity'
        )
        .removeAttr(
            'data-available-quantity'
        );

    /*
     * Aby se hláška při každém přepočtu
     * neduplikovala.
     */
    $variantWrap
        .children('.calendar-message')
        .remove();

    $variantWrap.append(
        '<div class="calendar-message">'
        + '<span>'
        + vybertetermin
        + '</span>'
        + '</div>'
    );

    if ($label.length) {
        $label.text(
            originalLabel
           // + ' - '
           // + vybertetermin
        );
    }

    if ($amount.length) {
        $amount
            .prop(
                'disabled',
                true
            )
            .removeAttr('max')
            .val(1);
    }

    if ($button.length) {
        $button
            .prop(
                'disabled',
                true
            )
            .attr(
                'aria-disabled',
                'true'
            )
            .addClass('disabled');
    }

    return;
}

/*
 * Sem se dostaneme až ve chvíli,
 * kdy je vybrané datum i čas.
 */
$variantWrap
    .children('.calendar-message')
    .remove();
        /*
         * Endpoint se ještě načítá.
         */
        if (
            !detailAvailabilityData
            || detailAvailabilityData
                .loading === true
            || detailAvailabilityData
                .loaded !== true
        ) {
            setDetailVariantLoading(
                $variant,
                $label,
                $amount,
                $button,
                originalLabel
            );

            return;
        }

        const product =
            productsByCode[code];

        /*
         * Produktový kód nebyl
         * v databázi nalezen.
         */
        if (!product) {
            setDetailVariantUnavailable(
                $variant,
                $label,
                $amount,
                $button,
                originalLabel,
                0,
                0,
                0
            );

            return;
        }

        const limitQuantity = Math.max(
            0,
            Number(
                product.limitQuantity
            ) || 0
        );

        const reservedQuantity = Math.max(
            0,
            Number(
                product.reservedQuantity
            ) || 0
        );

        const apiAvailableQuantity = Math.max(
            0,
            Number(
                product.availableQuantity
            ) || 0
        );

        /*
         * Skladový (native) max zachycený captureNativeVariantMax
         * dřív, než jsme o něj v DOM přišli. Pokud sklad povoluje
         * méně kusů než denní pekařský limit z API, respektujeme
         * ten nižší - nikdo tak nemůže objednat víc, než je
         * fyzicky na skladě.
         */
        const nativeMaxRaw = Number(
            $variant.attr('data-native-max-quantity')
        );

        const nativeMaxQuantity =
            Number.isFinite(nativeMaxRaw)
                ? nativeMaxRaw
                : Infinity;

        const availableQuantity = Math.min(
            apiAvailableQuantity,
            nativeMaxQuantity
        );

        const isAvailable = Boolean(
            product.exists === true
            && product.active === true
            && product.available === true
            && availableQuantity > 0
        );

        if (isAvailable) {
            setDetailVariantAvailable(
                $variant,
                $label,
                $amount,
                $button,
                originalLabel,
                limitQuantity,
                reservedQuantity,
                availableQuantity
            );

            return;
        }

        setDetailVariantUnavailable(
            $variant,
            $label,
            $amount,
            $button,
            originalLabel,
            limitQuantity,
            reservedQuantity,
            availableQuantity
        );
    });
}

function normalizeDetailAmount($amount) {
    if (!$amount.length) {
        return;
    }

    const minimum = Math.max(
        1,
        Number($amount.attr('min')) || 1
    );

    const effectiveMaxRaw =
        $amount.attr('data-effective-max-quantity');

    const maximum = Math.max(
        minimum,
        effectiveMaxRaw !== undefined
            ? (Number(effectiveMaxRaw) || minimum)
            : (Number($amount.attr('max')) || minimum)
    );

    let value = Number($amount.val());

    if (!Number.isFinite(value)) {
        value = minimum;
    }

    value = Math.floor(value);

    value = Math.max(
        minimum,
        Math.min(value, maximum)
    );

    $amount.val(value);
}


/**
 * Načte dostupnost detailu z endpointu.
 */
function loadDetailProductAvailability() {
    /*
     * Dostupnost produktu se má načíst až po
     * POTVRZENÍ termínu vyzvednutí, ne hned po
     * pouhém výběru data v kalendáři.
     */
    const date = getConfirmedPickupDate();

    /*
     * Bez potvrzeného data vyčistíme
     * předchozí data.
     */
    if (!date) {
        detailAvailabilityData = null;

        updateProductDetailAvailabilityMessage();
        updateDetailVariantAvailability();

        return;
    }

    const codes =
        getDetailProductCodes();

    if (!codes.length) {
        detailAvailabilityData = {
            loaded: true,
            loading: false,
            error: true,
            products: [],
            message:
                'Nepodařilo se zjistit kód produktu.'
        };

        updateProductDetailAvailabilityMessage();
        updateDetailVariantAvailability();

        return;
    }

    const requestId =
        ++detailAvailabilityRequestId;

    /*
     * Zrušení předchozího AJAX požadavku.
     */
    if (
        detailAvailabilityRequest
        && detailAvailabilityRequest
            .readyState !== 4
    ) {
        detailAvailabilityRequest.abort();
    }

    /*
     * Stav načítání.
     */
    detailAvailabilityData = {
        loaded: false,
        loading: true,
        error: false,
        products: [],
        date: formatDateForStorage(
            date
        )
    };

    updateProductDetailAvailabilityMessage();
    updateDetailVariantAvailability();

    detailAvailabilityRequest = $.ajax({
        url: availabilityEndpointUrl,

        method: 'POST',

        contentType:
            'application/json; charset=utf-8',

        dataType: 'json',

        data: JSON.stringify({
            date:
                formatDateForStorage(
                    date
                ),

            codes: codes
        }),

        timeout: 15000
    });

    detailAvailabilityRequest.done(
        function (response) {
            /*
             * Mezitím už mohl být
             * odeslán novější požadavek.
             */
            if (
                requestId
                !== detailAvailabilityRequestId
            ) {
                return;
            }

            if (
                !response
                || response.success !== true
                || !Array.isArray(
                    response.products
                )
            ) {
                detailAvailabilityData = {
                    loaded: true,
                    loading: false,
                    error: true,
                    products: [],
                    message:
                        'Endpoint vrátil neplatná data.'
                };

                updateProductDetailAvailabilityMessage();
                updateDetailVariantAvailability();

                return;
            }

            /*
             * Součty pro hlavní informační
             * hlášku produktu.
             */
            const totals =
                response.products.reduce(
                    function (
                        result,
                        product
                    ) {
                        if (
                            product.exists
                                !== true
                            || product.active
                                !== true
                        ) {
                            return result;
                        }

                        result.limitQuantity +=
                            Number(
                                product
                                    .limitQuantity
                            ) || 0;

                        result.reservedQuantity +=
                            Number(
                                product
                                    .reservedQuantity
                            ) || 0;

                        result.availableQuantity +=
                            Number(
                                product
                                    .availableQuantity
                            ) || 0;

                        result
                            .existingProductCount++;

                        return result;
                    },
                    {
                        limitQuantity: 0,
                        reservedQuantity: 0,
                        availableQuantity: 0,
                        existingProductCount: 0
                    }
                );

            detailAvailabilityData = {
                loaded: true,
                loading: false,
                error: false,

                date:
                    response.date,

                isoWeekday:
                    Number(
                        response.isoWeekday
                    ),

                weekday:
                    response.weekday,

                /*
                 * Jednotlivé varianty.
                 */
                products:
                    response.products,

                existingProductCount:
                    totals
                        .existingProductCount,

                limitQuantity:
                    totals.limitQuantity,

                reservedQuantity:
                    totals
                        .reservedQuantity,

                availableQuantity:
                    totals
                        .availableQuantity
            };

            /*
             * Hlavní hláška produktu.
             */
            updateProductDetailAvailabilityMessage();

            /*
             * Dostupnost jednotlivých variant.
             */
            updateDetailVariantAvailability();

            $(document).trigger(
                'klasekDetailAvailabilityLoaded',
                [
                    detailAvailabilityData,
                    response
                ]
            );
        }
    );

    detailAvailabilityRequest.fail(
        function (
            xhr,
            textStatus
        ) {
            if (textStatus === 'abort') {
                return;
            }

            if (
                requestId
                !== detailAvailabilityRequestId
            ) {
                return;
            }

            let message =
                'Dostupnost se nepodařilo načíst.';

            if (
                xhr.responseJSON
                && xhr.responseJSON.message
            ) {
                message =
                    xhr.responseJSON.message;
            }

            detailAvailabilityData = {
                loaded: true,
                loading: false,
                error: true,
                products: [],
                message: message
            };

            updateProductDetailAvailabilityMessage();
            updateDetailVariantAvailability();

            console.error(
                'Chyba availability endpointu:',
                xhr.status,
                xhr.responseText
            );
        }
    );
}





/**
 * Aktualizuje hlášku na detailu produktu.
 *
 * Dostupnost se rozhoduje podle:
 * 1. flagu dne pečení,
 * 2. skutečného množství z endpointu.
 */
function updateProductDetailAvailabilityMessage() {
    let date = selectedDate;

    if (!date) {
        date = parseStoredDate(
            localStorage.getItem(
                calendarConfig.storageDateKey
            )
        );
    }

    const $detail = $(
        '.type-detail .p-info-wrapper'
    ).first();

    if (!$detail.length) {
        return;
    }

    const $flagsWrapper = $detail
        .find('.flags-default')
        .first();

    let $message = $detail.find(
        '.selectedDateAvailability'
    );

    if (!$message.length) {
        $message = $(
            '<div class="selectedDateAvailability"></div>'
        );

        if ($flagsWrapper.length) {
            $flagsWrapper.after($message);
        } else {
            $detail.prepend($message);
        }
    }

    /*
     * Bez vybraného termínu hlášku skryjeme.
     */
    if (!date) {
        $message
            .hide()
            .removeClass(
                'is-loading '
                + 'is-available '
                + 'is-unavailable '
                + 'is-error'
            )
            .removeAttr(
                'data-limit-quantity'
            )
            .removeAttr(
                'data-reserved-quantity'
            )
            .removeAttr(
                'data-available-quantity'
            )
            .empty();

        return;
    }

    const isoWeekday = (
        date.getDay() === 0
            ? 7
            : date.getDay()
    );

    const selectedFlagClass =
        bakeDayFlagClasses[isoWeekday];

    /*
     * Zjištění, zda se produkt daný den peče.
     */
    const isBakeDay = Boolean(
        selectedFlagClass
        && $flagsWrapper.length
        && $flagsWrapper
            .find(
                '.flag.' + selectedFlagClass
            )
            .length
    );

    const formattedDate =
        formatDateDetailShort(date);

    /*
     * Pokud se produkt tento den vůbec nepeče,
     * nemusíme čekat na sklad.
     */
    if (!isBakeDay) {
        $('.variant').addClass('is-unavailable')
        $message
            .removeClass(
                'is-loading '
                + 'is-available '
                + 'is-error'
            )
            .addClass('is-unavailable')
            .html(
                '<p>'
                + 'Ve vámi zvolený termín '
                + '<strong>'
                + escapeHtml(formattedDate)
                + '</strong> '
                + 'není tento produkt dostupný. '
                + 'Pro objednání prosím '
                + '<button type="button" '
                + 'class="changeProductPickupDate">'
                + 'změňte termín vyzvednutí'
                + '</button>.'
                + '</p>'
            )
            .attr(
                'data-available-quantity',
                '0'
            )
            .show();

        return;
    }

    /*
     * Endpoint se teprve načítá.
     */
if (
    !detailAvailabilityData
    || detailAvailabilityData.loading === true
    || detailAvailabilityData.loaded !== true
) {
    const confirmedDate =
        getConfirmedPickupDate();

    if (!confirmedDate) {
        $message
            .removeClass(
                'is-available '
                + 'is-unavailable '
                + 'is-error '
                + 'is-loading'
            )
            .addClass('is-unavailable')
            .html(
                '<p>'
                + 'Potvrďte termín vyzvednutí.'
                + '</p>'
            )
            .show();

        return;
    }

    $message
        .removeClass(
            'is-available '
            + 'is-unavailable '
            + 'is-error'
        )
        .addClass('is-loading')
        .html(
            '<p>'
            + 'Ověřujeme dostupnost pro termín '
            + '<strong>'
            + escapeHtml(formattedDate)
            + '</strong>…'
            + '</p>'
        )
        .show();

    return;
}

    /*
     * Endpoint skončil chybou.
     */
    if (detailAvailabilityData.error === true) {
        $message
            .removeClass(
                'is-loading '
                + 'is-available '
                + 'is-unavailable'
            )
            .addClass('is-error')
            .html(
                '<p>'
                + escapeHtml(
                    detailAvailabilityData.message
                    || 'Dostupnost se nepodařilo načíst.'
                )
                + '</p>'
            )
            .show();

        return;
    }

    const limitQuantity = Number(
        detailAvailabilityData.limitQuantity
    ) || 0;

    const reservedQuantity = Number(
        detailAvailabilityData.reservedQuantity
    ) || 0;

    const availableQuantity = Number(
        detailAvailabilityData.availableQuantity
    ) || 0;

    /*
     * Dostupné pouze pokud:
     * - se daný den peče,
     * - produkt existuje,
     * - zbývá alespoň jeden kus.
     */
    const isAvailable = Boolean(
        isBakeDay
        && detailAvailabilityData
            .existingProductCount > 0
        && availableQuantity > 0
    );

    /*
     * Společný HTML výpis množství.
     */
    const quantitiesHtml =
        '<div class="availabilityQuantities">'

        + '<div class="availabilityQuantity">'
        + '<span>Kapacita</span>'
        + '<strong>'
        + limitQuantity
        + ' ks'
        + '</strong>'
        + '</div>'

        + '<div class="availabilityQuantity">'
        + '<span>Rezervováno</span>'
        + '<strong>'
        + reservedQuantity
        + ' ks'
        + '</strong>'
        + '</div>'

        + '<div class="availabilityQuantity">'
        + '<span>Zbývá</span>'
        + '<strong>'
        + availableQuantity
        + ' ks'
        + '</strong>'
        + '</div>'

        + '</div>';

    if (isAvailable) {
        
        $message
            .removeClass(
                'is-loading '
                + 'is-unavailable '
                + 'is-error'
            )
            .addClass('is-available')
            .html(
                '<p>'
                + 'Ve vámi zvolený termín '
                + '<strong>'
                + escapeHtml(formattedDate)
                + '</strong> '
                + 'je tento produkt dostupný.'
                + '</p>'
            //    + quantitiesHtml
            )
            .attr(
                'data-limit-quantity',
                limitQuantity
            )
            .attr(
                'data-reserved-quantity',
                reservedQuantity
            )
            .attr(
                'data-available-quantity',
                availableQuantity
            )
            .show();

        return;
    }

    $message
        .removeClass(
            'is-loading '
            + 'is-available '
            + 'is-error'
        )
        .addClass('is-unavailable')
        .html(
            '<p>'
            + 'Ve vámi zvolený termín '
            + '<strong>'
            + escapeHtml(formattedDate)
            + '</strong> '
            + 'není tento produkt dostupný. '
            + 'Pro objednání prosím '
            + '<button type="button" '
            + 'class="changeProductPickupDate">'
            + 'změňte termín vyzvednutí'
            + '</button>.'
            + '</p>'
            + quantitiesHtml
        )
        .attr(
            'data-limit-quantity',
            limitQuantity
        )
        .attr(
            'data-reserved-quantity',
            reservedQuantity
        )
        .attr(
            'data-available-quantity',
            availableQuantity
        )
        .show();
}
    

    function escapeHtml(value) {
        return $('<div>')
        .text(String(value))
        .html();
    }

    function renderPickupInCart() {
        const storedPickup = localStorage.getItem(
            calendarConfig.storagePickupKey
        );

        /*
        * Starý blok nejdříve odstraníme,
        * aby se po každém načtení košíku neduplikoval.
        */
        $('.cartPickupDateBox').remove();

        if (!storedPickup) {
            return;
        }

        let pickup;

        try {
            pickup = JSON.parse(storedPickup);
        } catch (error) {
            return;
        }

        const date = parseStoredDate(
            pickup.date
        );

        if (!date || !pickup.time) {
            return;
        }

        const pickupTime = getTimeStart(
            pickup.time
        );

        const $box = $(
            '<div class="selectedDateBox cartPickupDateBox">'
                + '<div class="selectedDateLabel">'
                    + 'Vybraný termín:'
                + '</div>'
                + '<div class="selectedDateRow">'
                    + '<strong class="selectedDateValue"></strong>'
                    + '<button type="button" class="changeCartPickupDate">'
                        + 'Změnit datum'
                    + '</button>'
                + '</div>'
            + '</div>'
        );

        $box
            .find('.selectedDateValue')
            .text(
                formatDateLong(date)
                + ', '
                + pickupTime
            );

        /*
        * Zde případně změň cílový selektor podle košíku.
        *
        * Skript zkouší několik běžných částí Shoptet košíku.
        */
        const $target = $(
            '#cart-widget .popup-widget-inner'
           // + '.cart-inner, '
           // + '.checkout-box, '
           // + '#content .cart-table'
        ).first();

        if ($target.length) {
            $target.prepend($box);
        }
    }

    /**
     * Znepřístupní / zpřístupní odkaz na košík v hlavičce
     * podle toho, jestli je potvrzený termín vyzvednutí.
     *
     * Na rozdíl od updateCartPickupNotice() se tohle
     * NEOMEZUJE na .id--9 - platí všude na webu.
     */
    function updateHeaderCartAccess() {
        const hasPickup = Boolean(
            getConfirmedPickupDate()
        );

        $(
            'a.toggle-window[data-target="cart"]'
        )
            .toggleClass(
                'is-pickup-required',
                !hasPickup
            )
            .attr(
                'aria-disabled',
                hasPickup
                    ? 'false'
                    : 'true'
            );
    }

    $(document).on(
        'click',
        'a.toggle-window[data-target="cart"]',
        function (event) {
            if (getConfirmedPickupDate()) {
                return;
            }

            /*
            * Bez potvrzeného termínu nejde
            * na košík kliknout - rovnou
            * otevřeme výběr termínu.
            */
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            $('.rezervace')
                .addClass('visible');

            if (selectedDate) {
                showTimeSelectionStep();
            } else {
                showDateSelectionStep();
            }
        }
    );

    /**
     * V košíku (omezeno na .id--9) upozorní, že není
     * vybraný termín vyzvednutí:
     * - do .cart-content .summary-wrapper přidá hlášku,
     * - na .cart-table přidá třídu "pickup-not-selected".
     *
     * Pozn.: pokud se skutečná struktura košíku liší
     * (např. jiné vnoření .cart-content/.summary-wrapper),
     * uprav selektory níže.
     */
    function updateCartPickupNotice() {
        const $scope = $('.id--9');

        if (!$scope.length) {
            return;
        }

        const hasPickup = Boolean(
            getConfirmedPickupDate()
        );

        $scope.find('.summary-wrapper').toggleClass('notAllowed', !hasPickup);

        $scope
            .find('.cart-table')
            .toggleClass(
                'pickup-not-selected',
                !hasPickup
            );

        const $summaryWrapper = $scope
            .find('.summary-wrapper')
            .first();

        if (!$summaryWrapper.length) {
            return;
        }

        const $existingMessage =
            $summaryWrapper.find(
                '.cartPickupMissingMessage'
            );

        if (hasPickup) {
            $existingMessage.remove();
            return;
        }

        if ($existingMessage.length) {
            return;
        }

        $summaryWrapper.addClass('notAllowed').prepend(
            '<div class="cartPickupMissingMessage">'
                + '<span>'
                    + 'Nemáte vybraný termín vyzvednutí. Vraťte se <a href="/">zpět do obchodu</a> '
                    
                + '</span>'
            + '</div>'
        );
    }

    $(document).on(
    'click',
    '.changeProductPickupDate',
    function (event) {
        event.preventDefault();

        $('.rezervace')
            .addClass('visible');

        if (selectedDate) {
            showTimeSelectionStep();
        } else {
            showDateSelectionStep();
        }
    }
);

    
    $(document).on(
        'click',
        '.changeCartPickupDate',
        function (event) {
            event.preventDefault();

            $('.rezervace')
                .addClass('visible');

            if (selectedDate) {
                showTimeSelectionStep();
            } else {
                showDateSelectionStep();
            }
        }
    );

function renderCategoryInfoBox() {
    const isHomepage = $('body').hasClass('in-index');

    /*
     * Na homepage a v kategorii může být jiný cílový element.
     * Selektor pro homepage případně uprav podle své šablony.
     */
 
    const $wrapper = isHomepage
        ? $('.bakery-tabs .bakery-tabs__panels').first()
        : $('.category-content-wrapper').first();
    if (!$wrapper.length) {
        return;
    }

    const storedPickup = localStorage.getItem(
        calendarConfig.storagePickupKey
    );

    /*
     * Pokud termín není potvrzený, infoBox odstraníme.
     */
    if (!storedPickup) {
        $wrapper.find('.infoBox').remove();
        if (isHomepage) {
            $wrapper.prepend(
                '<div class="infoBox infoBox--no-date infoBox--homepage">'
                    + '<span>'
                        + 'Pro zobrazení nabídky na konkrétní den '
                        + '<button type="button" class="changeCategoryPickupDate">'
                            + 'vyberte termín vyzvednutí'
                        + '</button>.'
                    + '</span>'
                + '</div>'
            );
        }
        else{
            $wrapper.prepend(
            '<div class="infoBox infoBox--no-date">'
                + '<span>'
                    + 'Pro zobrazení nabídky na konkrétní den '
                    + '<button type="button" class="changeCategoryPickupDate">'
                        + 'vyberte termín vyzvednutí'
                    + '</button>.'
                + '</span>'
            + '</div>'
        );
        }
        

        return;
    }

    let pickup;

    try {
        pickup = JSON.parse(storedPickup);
    } catch (error) {
        $wrapper.find('.infoBox').remove();
        return;
    }

    const date = parseStoredDate(pickup.date);

    if (!date) {
        $wrapper.find('.infoBox').remove();
        return;
    }

    const formattedDate = formatDateLong(date);

    $wrapper.find('.infoBox--no-date').remove();
    let $infoBox = $wrapper.find('.infoBox');

    if (!$infoBox.length) {
        /*
         * Obsah pro homepage.
         */
        if (isHomepage) {
            $wrapper.prepend(
                '<div class="infoBox infoBox--homepage">'
                    + '<span>'
                        + 'Aktuálně zobrazujeme nabídku pečiva na '
                        + '<strong class="infoBoxDate"></strong>. '
                        + '<button type="button" class="changeCategoryPickupDate">'
                            + 'Změnit termín vyzvednutí'
                        + '</button>'
                    + '</span>'
                + '</div>'
            );
        }

        /*
         * Obsah pro kategorii a ostatní stránky.
         */
        else {
            $wrapper.prepend(
                '<div class="infoBox infoBox--category">'
                    + '<span>'
                        + 'Zobrazujeme Vám nabídku na '
                        + '<strong class="infoBoxDate"></strong>. '
                        + 'Chcete-li zobrazit nabídku na jiný den, '
                        + '<button type="button" class="changeCategoryPickupDate">'
                            + 'změňte termín vyzvednutí'
                        + '</button>.'
                    + '</span>'
                + '</div>'
            );
        }

        $infoBox = $wrapper.find('.infoBox');
    }

    $infoBox
        .find('.infoBoxDate')
        .text(formattedDate);
}
    $(document).on(
        'click',
        '.changeCategoryPickupDate',
        function (event) {
            event.preventDefault();

            $('.rezervace').addClass('visible');

            if (selectedDate) {
                showTimeSelectionStep();
            } else {
                showDateSelectionStep();
            }
        }
    );

    $(document).on('click', '.calendar-message span', function(event){
            event.preventDefault();

            $('.rezervace').addClass('visible');

            if (selectedDate) {
                showTimeSelectionStep();
            } else {
                showDateSelectionStep();
            }
    });

    function timeToMinutes(value) {
    if (!value) {
        return null;
    }

    if (!/^\d{1,2}:\d{2}$/.test(String(value).trim())) return null;
    const parts = String(value).trim().split(':');

    if (parts.length !== 2) {
        return null;
    }

    if (Number(parts[0]) > 23 || Number(parts[1]) > 59) return null;
    return (
        Number(parts[0]) * 60
        + Number(parts[1])
    );
}


    function getOpeningHoursForDate(date) {
        const dateKey = formatDateForStorage(date);

        /*
        * 1. Výjimečně otevřeno / prodloužená otevírací doba.
        * Má nejvyšší prioritu.
        *
        * Díky tomu lze otevřít i státní svátek.
        */
        if (
            calendarConfig.manualExtendedHours
            && calendarConfig.manualExtendedHours[dateKey]
        ) {
            const exception =
                calendarConfig.manualExtendedHours[dateKey];

            return {
                open: true,
                from: exception.open,
                to: exception.close,
                exception: true
            };
        }

        /*
        * 2. Výjimečně zavřeno.
        */
        if (
            calendarConfig.extraClosedDates.includes(
                dateKey
            )
        ) {
            return {
                open: false,
                exception: true,
                reason:
                    calendarConfig.extraClosedDateLabels[
                        dateKey
                    ]
                    || 'Zavřeno'
            };
        }

        /*
        * 3. Státní svátky.
        */
        const holidays =
            getCzechHolidays(
                date.getFullYear()
            );

        if (holidays[dateKey]) {
            return {
                open: false,
                holiday: true,
                reason: holidays[dateKey]
            };
        }

        /*
        * 4. Běžná otevírací doba.
        */
        const dayKeys = [
            'ne',
            'po',
            'ut',
            'st',
            'ct',
            'pa',
            'so'
        ];

        const dayKey =
            dayKeys[date.getDay()];

        const supportHours =
            calendarConfig.supportHours || [];

        const row =
            supportHours.find(function (item) {
                return item[0] === dayKey;
            });

        if (
            !row
            || !row[1]
        ) {
            return {
                open: false
            };
        }

        const parts =
            String(row[1]).split('-');

        if (parts.length !== 2) {
            return {
                open: false
            };
        }

        return {
            open: true,
            from: parts[0].trim(),
            to: parts[1].trim()
        };
    };





    /*
     * =========================================================
     * INICIALIZACE
     * =========================================================
     */
    document.addEventListener('ShoptetDOMPageContentLoaded', renderCategoryInfoBox);
    document.addEventListener('ShoptetPageSortingChanged', renderCategoryInfoBox);
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', renderCategoryInfoBox);

    document.addEventListener('ShoptetDOMContentLoaded', function(){
        renderPickupInCart();
        updateCartPickupNotice();
    });

    document.addEventListener('ShoptetDOMPageContentLoaded', function(){
        updateBakeDayFlags();
    });
    document.addEventListener('ShoptetPageSortingChanged', function(){
        updateBakeDayFlags();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function(){
        updateBakeDayFlags();
    });
    document.addEventListener('ShoptetDOMContentLoaded', function(){
        updateBakeDayFlags();
    });

    

    

    $(function () {
        ensureReservationUi();
        initializeState();
        renderCategoryInfoBox();
        renderCalendar();
        renderSelectedTime();
        updateConfirmationButton();
        updateResponsiveReservationButton();
        startOrderCountdown();

        updateBakeDayFlags();
        loadDetailProductAvailability();
        updateHeaderCartAccess();
        updateCartPickupNotice();
        renderPickupInCart();

        if (selectedDate) {
            showTimeSelectionStep();
        } else {
            showDateSelectionStep();
        }
        initTooltips();
    });

    /*
     * =========================================================
     * VEŘEJNÉ API
     * =========================================================
     */

    window.klasekCalendar = {
        config: calendarConfig,

        render: function () {
            renderCalendar();
            updateOrderBox();
        },

        open: function () {
            $('.rezervace')
                .addClass('visible');

            if (selectedDate) {
                showTimeSelectionStep();
            } else {
                showDateSelectionStep();
            }
        },

        close: function () {
            $('.rezervace')
                .removeClass('visible');
        },

        getSelectedDate: function () {
            return selectedDate
                ? formatDateForStorage(
                    selectedDate
                )
                : null;
        },

        getSelectedTime: function () {
            return selectedTime;
        },

        getConfirmedPickup: function () {
            const value =
                localStorage.getItem(
                    calendarConfig.storagePickupKey
                );

            if (!value) {
                return null;
            }

            try {
                return JSON.parse(value);
            } catch (error) {
                return null;
            }
        },

        getMinimumSelectableDate:
            function () {
                return formatDateForStorage(
                    getMinimumSelectableDate()
                );
            },

        addExtraClosedDate: function (
            date,
            label
        ) {
            if (
                !calendarConfig
                    .extraClosedDates
                    .includes(date)
            ) {
                calendarConfig
                    .extraClosedDates
                    .push(date);
            }

            if (label) {
                calendarConfig
                    .extraClosedDateLabels[
                        date
                    ] = label;
            }

            /*
             * Pokud byl právě uzavřen vybraný den,
             * aktuální výběr se smaže.
             */
            if (
                selectedDate
                && formatDateForStorage(
                    selectedDate
                ) === date
            ) {
                clearSelection();
                return;
            }

            renderCalendar();
        },

        removeExtraClosedDate:
            function (date) {
                calendarConfig
                    .extraClosedDates =
                    calendarConfig
                        .extraClosedDates
                        .filter(
                            function (item) {
                                return item
                                    !== date;
                            }
                        );

                delete calendarConfig
                    .extraClosedDateLabels[
                        date
                    ];

                renderCalendar();
            },

        clearSelection:
            clearSelection
    };
})(jQuery);

